import React from 'react'
import { t } from '../i18n'
import { ClockIcon, FlameIcon } from './Icons'

/* Sticky "Najčitanije | Najnovije" tabs on topic, source, category and search
   pages (spec 5.6): orange line under the active tab, its icon orange.
   onReselect fires on the already active tab (scroll up / refresh, spec 6). */
export default function SortTabs({ value, onChange, onReselect }) {
  const tab = (key, label, Icon) => (
    <button
      type="button"
      role="tab"
      aria-selected={value === key}
      className={`sort-tab ${value === key ? 'active' : ''}`}
      onClick={() => (value === key ? onReselect?.() : onChange(key))}
    >
      <Icon size={16} className={`chip-icon ${value === key ? 'on' : ''}`} />
      <span>{label}</span>
    </button>
  )
  return (
    <div className="sort-tabs" role="tablist" aria-label={t('tabs.label')}>
      {tab('top', t('chips.mostRead'), FlameIcon)}
      {tab('new', t('chips.newest'), ClockIcon)}
    </div>
  )
}
